import { defineMessages } from 'react-intl';
export default defineMessages({
    addAStation: {
        id: 'stations.addAStation',
        defaultMessage: 'Add a station'
    },
    addToFavorites: {
        id: 'stations.addToFavorites',
        defaultMessage: 'Add to favorites'
    },
    addYourOwnStation: {
        id: 'stations.addYourOwnStation',
        defaultMessage: 'Add your own station'
    },
    clearRecentLocations: {
        id: 'stations.clearRecentLocations',
        defaultMessage: 'Clear all'
    },
    clearSearch: {
        id: 'stations.clearSearch',
        defaultMessage: 'Clear search'
    },
    currentLocation: {
        id: 'stations.currentLocation',
        defaultMessage: 'Current location'
    },
    customizedStationName: {
        id: 'stations.customizedStationName',
        defaultMessage: 'Customized station name'
    },
    favoriteLocations: {
        id: 'stations.favoriteLocations',
        defaultMessage: 'Favorites'
    },
    favoriteLocationsEmpty: {
        id: 'stations.favoriteLocationsEmpty',
        defaultMessage: 'You can add up to 5 favorite locations.'
    },
    favoriteStations: {
        id: 'stations.favoriteStations',
        defaultMessage: 'Favorite stations'
    },
    filterStationDescription: {
        id: 'stations.filterStationDescription',
        defaultMessage: 'Do not display stations with unreliable measures'
    },
    filterStations: {
        id: 'stations.filterStations',
        defaultMessage: 'Filter stations'
    },
    filterStationSourceDescription: {
        id: 'stations.filterStationSourceDescription',
        defaultMessage: 'Select station providers that you want to display on the map'
    },
    findStationsNearYou: {
        id: 'stations.findStationsNearYou',
        defaultMessage: 'Find Stations Near You'
    },
    hideStationNamed: {
        id: 'stations.hideStationNamed',
        defaultMessage: 'Hide {station}'
    },
    hiddenStations: {
        id: 'stations.hiddenStations',
        defaultMessage: 'Hidden stations'
    },
    hiddenStationsDescription: {
        id: 'stations.hiddenStationsDescription',
        defaultMessage: 'You can unhide a station by tapping the eye icon next to it.'
    },
    lastSeen: {
        id: 'stations.lastSeen',
        defaultMessage: 'last seen {time}'
    },
    loadingStation: {
        id: 'stations.loadingStation',
        defaultMessage: 'Loading station…'
    },
    location: {
        id: 'stations.location',
        defaultMessage: 'Location'
    },
    locationAddedToFavorites: {
        id: 'stations.locationAddedToFavorites',
        defaultMessage: 'Location added to favorites'
    },
    locationNotGranted: {
        id: 'stations.locationNotGranted',
        defaultMessage: 'Location permission is not granted. Please allow access to your location in device settings.'
    },
    locationRemovedFromFavorites: {
        id: 'stations.locationRemovedFromFavorites',
        defaultMessage: 'Location removed from favorites'
    },
    locationUnavailable: {
        id: 'stations.locationUnavailable',
        defaultMessage: 'Unable to get your location. Please check your device settings.'
    },
    locations: {
        id: 'stations.locations',
        defaultMessage: 'Locations'
    },
    maxFavoriteLocationsReached: {
        id: 'stations.maxFavoriteLocationsReached',
        defaultMessage: 'You can only have up to 5 favorite locations. Remove one to add another.'
    },
    modifyFavoriteStations: {
        id: 'stations.modifyFavoriteStations',
        defaultMessage: 'Modify favorite stations'
    },
    modifyFavoriteStationsDescription: {
        id: 'stations.modifyFavoriteStationsDescription',
        defaultMessage: 'You can reorder your favorite stations by dragging them. You can also remove them from the list.'
    },
    myLocation: {
        id: 'stations.myLocation',
        defaultMessage: 'My location'
    },
    nearbyWeatherStations: {
        id: 'stations.nearbyWeatherStations',
        defaultMessage: 'Nearby weather stations'
    },
    noLocationsFound: {
        id: 'stations.noLocationsFound',
        defaultMessage: 'No locations found'
    },
    noLongerReported: {
        id: 'stations.noLongerReported',
        defaultMessage: 'No longer reported'
    },
    noLongerReportedBy: {
        id: 'stations.noLongerReportedBy',
        defaultMessage: 'No longer reported by {provider} since {date}'
    },
    noSearchResults: {
        id: 'stations.noSearchResults',
        defaultMessage: 'No articles match your search'
    },
    noStationsFound: {
        id: 'stations.noStationsFound',
        defaultMessage: 'No Stations Found'
    },
    noWeatherStationYet: {
        id: 'stations.noWeatherStationYet',
        defaultMessage: "You don't have a weather station yet."
    },
    recentLocations: {
        id: 'stations.recentLocations',
        defaultMessage: 'Recent'
    },
    recentLocationsEmpty: {
        id: 'stations.recentLocationsEmpty',
        defaultMessage: 'Your recent history is empty.'
    },
    removeFromFavorites: {
        id: 'stations.removeFromFavorites',
        defaultMessage: 'Remove from favorites'
    },
    removeStationNamed: {
        id: 'stations.removeStationNamed',
        defaultMessage: 'Remove {station} from favorites'
    },
    reorderStationNamed: {
        id: 'stations.reorderStationNamed',
        defaultMessage: 'Reorder {station}'
    },
    searchForLocation: {
        id: 'stations.searchForLocation',
        defaultMessage: 'Search for a location'
    },
    searchForWeatherStation: {
        id: 'stations.searchForWeatherStation',
        defaultMessage: 'Search for a weather station'
    },
    searchResults: {
        id: 'stations.searchResults',
        defaultMessage: 'Search results'
    },
    searchResultsEmpty: {
        id: 'stations.searchResultsEmpty',
        defaultMessage: 'No results found.'
    },
    searchResultsFound: {
        id: 'stations.searchResultsFound',
        defaultMessage: '{count, plural, one {# result found} other {# results found}}'
    },
    searchStationsDescription: {
        id: 'stations.searchStationsDescription',
        defaultMessage: 'Enter a city, address, or place name to find weather stations nearby.'
    },
    searchStationsHint: {
        id: 'stations.searchStationsHint',
        defaultMessage: 'Use the search bar above to discover weather stations in any location around the world.'
    },
    selectStationForComparison: {
        id: 'stations.selectStationForComparison',
        defaultMessage: 'Select a station to compare with'
    },
    stationAddedToFavorites: {
        id: 'stations.stationAddedToFavorites',
        defaultMessage: 'Station added to favorites'
    },
    stationCount: {
        id: 'stations.stationCount',
        defaultMessage: '{count, plural, one {# station} other {# stations}}'
    },
    stationInformation: {
        id: 'stations.stationInformation',
        defaultMessage: 'Station information'
    },
    stationName: {
        id: 'stations.stationName',
        defaultMessage: 'Station name'
    },
    stationObservationsDescription: {
        id: 'stations.stationObservationsDescription',
        defaultMessage: 'Display the latest observations from weather stations'
    },
    stationRemovedFromFavorites: {
        id: 'stations.stationRemovedFromFavorites',
        defaultMessage: 'Station removed from favorites'
    },
    stationsLoading: {
        id: 'stations.stationsLoading',
        defaultMessage: 'Loading weather stations'
    },
    stationsNear: {
        id: 'stations.stationsNear',
        defaultMessage: 'Stations near {place}'
    },
    stationType: {
        id: 'stations.stationType',
        defaultMessage: 'Station type'
    },
    statusOffline: {
        id: 'stations.statusOffline',
        defaultMessage: 'Offline'
    },
    statusOnline: {
        id: 'stations.statusOnline',
        defaultMessage: 'Online'
    },
    statusStale: {
        id: 'stations.statusStale',
        defaultMessage: 'Stale'
    },
    unhideStationNamed: {
        id: 'stations.unhideStationNamed',
        defaultMessage: 'Unhide {station}'
    },
    tryAnotherLocation: {
        id: 'stations.tryAnotherLocation',
        defaultMessage: "We couldn't find any weather stations near this location. Try searching for a different area."
    },
    weatherStation: {
        id: 'stations.weatherStation',
        defaultMessage: 'Weather station'
    },
    weatherStationCount: {
        id: 'stations.weatherStationCount',
        defaultMessage: '{count, plural, one {# weather station} other {# weather stations}}'
    },
    weatherStations: {
        id: 'stations.weatherStations',
        defaultMessage: 'Weather stations'
    },
    welcomeConnectService: {
        id: 'stations.welcomeConnectService',
        defaultMessage: 'Own a weather station? Connect your service'
    },
    welcomeSubtitle: {
        id: 'stations.welcomeSubtitle',
        defaultMessage: 'Your weather, all in one place'
    }
});
